import Excel from "exceljs";
import { saveAs } from "file-saver";
//---------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    getDatefromWeekNum, 
    getMonthfromWeekNum, 
    month, 
    outsideWorkingOns, 
    outsideNotWorkingReasons, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredForms, 
    week, 
    weekDay, 
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const handleExport = () => {
        setShowLoader(true);
        //--------------------------------------------------
        const pos = e => {
            switch(e){
                case "locator":
                    return "Locator";
                case "qew":
                    return "QEW";
                case "standby":
                    return "StandBy";
                default:
                    return "";
            }
        }
        const mainData = filteredForms.map(c => ({...c[week].form[weekDay], 
            lanId: c.lanId,
            residence: c.residence,
            phoneNumber: c.phoneNumber,
            outside: pos(c.outside),
            firstName: c.firstName,
            lastName: c.lastName
        })).filter(c => c.working);
        if(!mainData.length){
                window.alert("Nobody submitted.");
                return;
            }
        const workbook = new Excel.Workbook();                            
        workbook.creator = user.userName;
        workbook.created = new Date();
        workbook.calcProperties.fullCalcOnLoad = true; 
        const worksheet = workbook.addWorksheet();
        worksheet.state = "visible";
        worksheet.properties.defaultColWidth = 18;
   
        const divisionNames = divisions.data.map(d => d.division).filter(name => name !== "");
        const rows = mainData.map(d => {
            if(d.division !== "" && !divisionNames.includes(d.division)) divisionNames.push(d.division);
            return [
            d.lastName, // 1
            d.firstName, // 2
            d.lanId, // 3
            "Bess", // 4
            d.residence, // 5
            getMonthfromWeekNum(week, weekDay), // 6
            getDatefromWeekNum(week, weekDay), // 7
            d.phoneNumber, // 8
            d.working, // 9
            d.notWorkingReason, // 10
            d.commuteOrHotel, // 11
            d.division, // 12
            d.workingOn, // 13
            d.outside // 14
        ]});
        worksheet.addTable({
            name: "MyTable",
            ref: "A1",
            headerRow: true,
            style: {
                theme: "TableStyleMedium9",
                showRowStripes: true,
            },
            columns: [
                {name: "Last Name", filterButton: true}, // 1
                {name: "First Name", filterButton: true}, // 2
                {name: "Lan Id", filterButton: true}, // 3
                {name: "Vendor", filterButton: true}, // 4
                {name: "EE City Residence", filterButton: true}, // 5
                {name: "Month", filterButton: true}, // 6
                {name: "Today's Date", filterButton: true}, // 7
                {name: "EE Phone Number", filterButton: true}, // 8
                {name: "Working", filterButton: true}, // 9
                {name: "If Not Working - Reason", filterButton: true}, // 10
                {name: "Commute or Hotel", filterButton: true}, // 11
                {name: "Division", filterButton: true}, // 12
                {name: "Working On", filterButton: true}, // 13
                {name: "Position", filterButton: true}, // 14
            ],
            rows: rows,
        });
        const divisionsText = `"${divisionNames.join(",")}"`;
        const outsideWorkingOnsText = `"${outsideWorkingOns.join(",")}"`;
        const outsideNotWorkingReasonsText = `"${outsideNotWorkingReasons.join(",")}"`;
        for(let iiii = 0; iiii < rows.length; iiii++){
            worksheet.getCell(2 + iiii, 4/*#*/).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"Bess"`]
            };
            worksheet.getCell(2 + iiii, 6/*#*/).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"${month.join(",")}"`]
            };
            worksheet.getCell(2 + iiii, 9/*#*/).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"Yes,No"`]
            };
            if(outsideNotWorkingReasonsText.length <= 255){
                worksheet.getCell(2 + iiii, 10/*#*/).dataValidation = {
                    type: "list",
                    allowBlank: true,
                    formulae: [ outsideNotWorkingReasonsText ]
                };
            }
            worksheet.getCell(2 + iiii, 11/*#*/).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"Hotel,Commute"`]
            };
            if(divisionsText.length <= 255){
                worksheet.getCell(2 + iiii, 12/*#*/).dataValidation = {
                    type: "list",
                    allowBlank: true,
                    formulae: [ divisionsText ]
                };
            }
            if(outsideWorkingOnsText.length <= 255){
                worksheet.getCell(2 + iiii, 13/*#*/).dataValidation = {
                    type: "list",
                    allowBlank: true,
                    formulae: [ outsideWorkingOnsText ]
                };
            }
            worksheet.getCell(2 + iiii, 14/*#*/).dataValidation = {
                type: "list",
                allowBlank: true,
                formulae: [`"Locator,QEW,Standby"`]
            };
            for(let iiiii = 0; iiiii < 6; iiiii++){
                worksheet.getCell(2 + iiii, 6 + iiiii/*#*/).style = {
                    alignment: {
                        vertical: "middle", 
                        horizontal: "center"
                    },
                }
            }
        }
        worksheet.columns.forEach(column => {
            const minLength = 18;
            let maxLength = 0;
            column["eachCell"]({ includeEmpty: true }, cell => {
                const columnLength = cell.value?
                cell.value.toString().length * (cell.font?cell.font.size / 11 * 1.2:1)
                :minLength;
                if(columnLength > maxLength){
                    maxLength = columnLength;
                }
            });
            column.width = maxLength < minLength ? minLength : maxLength;
        });
        //--------------------------------------------------
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx }), 
            `Daily Call Out ${getDatefromWeekNum(week, weekDay).slice(5)}.xlsx`);
            setShowLoader(false);
        });
        //--------------------------------------------------
    }
    //--------------------------------------------------------------------------------------------
    return(
        <span className = "pointer" onClick = {() => handleExport()}>Export</span>
    )
}